import React, { useState, useContext } from 'react'
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ModalWindow from '../../layout/modalwindow/ModalWindow';
import { ContentHeader } from '../../layout/Content'
import Searchbar from '../../layout/searchbar/Searchbar'
import ToolbarButton  from '../../layout/ToolbarButton'
import CustomersAccountsListHeaderStyle from './css/CustomersAccountsListHeaderStyle'
import CustomersAccountsListSettingsForm from './form/CustomersAccountsListSettingsForm'
import { appContext } from '../../../App'
import { customersAccountsListControllerContext } from './CustomersAccountsListController'

function ToolBarButtons(props) {
  const app = useContext(appContext)
  const customersAccountsListController = useContext(customersAccountsListControllerContext)
  const {
    reloadCustomersAccountsList,
    selectedCustomersAccount,
    deleteSelectedCustomersAccount,
    showRegisterCustomerAccountForm,
  } = customersAccountsListController

  const searchInput = props.searchInput[0]

  const onClickRefresh = () => reloadCustomersAccountsList()

  const onClickSettings = () => {
    ReactDOM.render(
      <ModalWindow id='mw-parent' width='30' height='50' header='Settings' footer={null}>
        <CustomersAccountsListSettingsForm app={app} customersAccountsListController={customersAccountsListController} />
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickAddNewCustomerAccount = () => showRegisterCustomerAccountForm(app)

  const onClickDeleteSelectedCustomers = () => {
    const onClick = (button) => {
      if (button === 'Yes')  deleteSelectedCustomersAccount()
      ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
    }
    const showMessageBox = () => {
      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          height='30'
          width='35'
          header="Delete Record"
          footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>Will delete selected (marked checked) customer accounts record!</div>
              <br/>
              <div>Do you want to continue?</div>
            </div>
            <div className='button-container'>
              <button onClick={() => { onClick('No') }} className='pospro-action-btn top-anchor'>No</button>
              <button onClick={() => { onClick('Yes')}} className='pospro-action-btn bottom-anchor'>Yes</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    showMessageBox()
  }

  return (
    <ToolbarButton>
      <button
        type="button"
        className={ searchInput ? 'pospro-action-btn toolbar-btn disabled-button' : 'pospro-action-btn toolbar-btn' }
        id="refresh-list"
        disabled={searchInput}
        name="tb"
        onClick={onClickRefresh}
        title='Refresh list'>
        <FontAwesomeIcon icon='sync-alt'/>
        <span className='tooltip-text'>Refresh list</span>
      </button>
      <button
        type="button"
        className="pospro-action-btn toolbar-btn"
        id="settings"
        name="tb"
        onClick={onClickSettings}
        title='Settings'>
        <FontAwesomeIcon icon='cog'/>
        <span className='tooltip-text'>Settings</span>
      </button>
      <button
        type="button"
        className="pospro-action-btn toolbar-btn"
        id="add-new-customer"
        name="tb"
        onClick={onClickAddNewCustomerAccount}
        title='New customer account'>
        <FontAwesomeIcon icon='plus'/>
        <span className='tooltip-text'>New Customer Account</span>
      </button>
      <button
        type="button"
        className={ selectedCustomersAccount.length ? 'pospro-action-btn toolbar-btn' : 'pospro-action-btn disabled-button' }
        id="batch-delete"
        disabled={!selectedCustomersAccount.length}
        name="tb"
        onClick={onClickDeleteSelectedCustomers}
        title='Batch delete'>
        <FontAwesomeIcon icon='trash'/>
        <span className='tooltip-text'>Batch delete</span>
      </button>
    </ToolbarButton>
  )
}

function CustomersAccountsListHeader() {
  const app = useContext(appContext)
  const [searchInput, setSearchInput] = useState('')
  const customersAccountsListController = useContext(customersAccountsListControllerContext)
  const { filterCustomersAccounts } = customersAccountsListController

  const searchbarProps = {
    search: searchInput,
    setSearch: setSearchInput,
    filter: filterCustomersAccounts,
  }

  return (
    <ContentHeader title='Customers Accounts List'>
      <div className="header-container">
        <div id="customer-accounts-list-toolbar">
          <Searchbar { ...searchbarProps } />
          <ToolBarButtons searchInput={[searchInput, setSearchInput]} />
        </div>
      </div>
      <CustomersAccountsListHeaderStyle signed_in={app.client.signed_in}/>
    </ContentHeader>
  )
}

export default React.memo(CustomersAccountsListHeader)
